import { Dispatch, SetStateAction } from 'react';
import PagerView from './pager-view';

function Pager({
    elements,
    page,
    setPage,
    numberOfResults
} : {
    page: number,
    setPage: Dispatch<SetStateAction<number>>,
    elements: any[],
    numberOfResults: number
}) {
    return (
        <PagerView 
            elements={elements}
            page={page}
            setPage={setPage}
            numberOfResults={numberOfResults}
        />
    )
}

export default Pager;